<template>
    <div class="dataset-monitor-type-1">
        <div class="dataset-wrapper">
            <div class="section-title" v-html="$t(datasetStore.name ? 'components.dataset_monitor.title_alt' : 'components.dataset_monitor.title', { name: datasetStore.name })"></div>
            <div class="dataset-count" v-if="showCount">
                <div class="chars">
                    <div class="count">{{ datasetStore.loading ? '...' : (datasetStore.count || datasetStore.count === 0) ? formatNumber(datasetStore.count) : formatNumber('3000000', '', '+') }}</div>
                    <div class="name h6">{{ $t('common.organizations') }}</div>
                </div>
                <div class="chars">
                    <div class="count">{{ datasetStore.loading || !datasetStore.finalPrice ? '€...' : formatNumber(datasetStore.finalPrice, '€', '', 2) }}</div>
                    <div class="name h6">{{ $t('common.ex_vat') }}</div>
                </div>
            </div>

            <DatasetSelection :canModify="canModify" />
            <div class="table-wrapper" v-if="showExamples && (companies?.length > 0 || datasetStore.loading)">
                <div class="h6 name">{{$t('common.examples_1')}}</div>
                <ExamplesTable :summarized="true" />
            </div>
            <DatasetShare v-if="showShare" />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import { formatNumber } from '@/utils/formatting';
    import DatasetSelection from '@/components/builder/monitor/DatasetSelection';
    import DatasetShare from '@/components/builder/monitor/DatasetShare';
    import ExamplesTable from '@/components/builder/misc/ExamplesTable';

    export default {
        name: 'DatasetMonitor',
        components: {
            DatasetSelection,
            DatasetShare,
            ExamplesTable
        },
        props: {
            showCount: {
                type: Boolean,
                default: true
            },
            showExamples: {
                type: Boolean,
                default: true
            },
            showShare: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapState(useDatasetStore, ['dataset', 'companies']),
            datasetStore() {
                return useDatasetStore();
            },
            canModify() {
                return this.$route.name === 'builder';
            }
        },
        methods: {
            formatNumber
        }
    }
</script>